import React, { useState, useEffect } from 'react'
//import FooterPrime from '../container/Footer/Footer'
//import { SB_Header, Navbar, SB_Anecdotas, SB_Timeline, Footer } from '../container'
import { Header_2026, Footer_2026, Sobremi_inicio_2026, Sobremi_ideas_2026, Sobremi_libros_2026, Sobremi_newsletter_2026, Sobremi_blogs_2026 } from '../container';

import { Helmet } from "react-helmet";

const SobreMi = () => {
  {/* 
  const [fontSize, setFontSize] = useState(12); 

  const aumentarTamañoFuente = () => {
    if (fontSize < 16) {
      setFontSize(prevSize => prevSize + 1); 
    }
  };

  const disminuirTamañoFuente = () => {
    if (fontSize > 9) {
      setFontSize(prevSize => prevSize - 1); 
    }
  };
*/}
  return (
    <div className='App'>
      <Header_2026 />
      <div className='about-page'>
        <Sobremi_inicio_2026 />
        <Sobremi_ideas_2026 />
        <Sobremi_libros_2026 />
        <Sobremi_newsletter_2026 />
        <Sobremi_blogs_2026 />
      </div>
      <Footer_2026 />
      {/* 
      <style>
        {`@media only screen and (max-width: 700px) {
              .SB_movil p {
              font-size: ${fontSize}px !important;
              }
            }`}
      </style>
      <div className='barra_texto_sm_1'>


        <button onClick={disminuirTamañoFuente}>A -</button>
        <button onClick={aumentarTamañoFuente}>A +</button>
      </div>
    */}

    </div>
  )
}

export default SobreMi
